import React, { useMemo } from 'react';
import Pills from '@/components/Pills';

const ExploreCategoryPills = React.memo(({ categories, activeSlug, activeMediaType, onSelect }) => {
  const filtered = useMemo(() => {
    if (!categories?.length) return [];
    return categories.filter(cat => {
      if (!activeMediaType) return true;
      if (!cat.mediaTypes?.length) return true;
      return cat.mediaTypes.includes(activeMediaType);
    });
  }, [categories, activeMediaType]);

  const items = useMemo(() => {
    const all = [{ id: '__all__', label: 'All' }];
    const cats = filtered.map(cat => ({
      id: cat.slug,
      label: cat.name,
      icon: cat.icon || undefined,
    }));
    return [...all, ...cats];
  }, [filtered]);

  if (filtered.length === 0) return null;

  return (
    <Pills
      items={items}
      activeId={activeSlug || '__all__'}
      onChange={(id) => onSelect(id === '__all__' ? null : id)}
      size="s"
      hasBackground
      scrollToActiveId
      containerStyle={{ paddingHorizontal: 16 }}
    />
  );
});

ExploreCategoryPills.displayName = 'ExploreCategoryPills';

export default ExploreCategoryPills;
